import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { HttpClient } from '@angular/common/http';
import { EndpointsService } from 'src/app/services/endpoints.service';
import { ModalControlService } from 'src/app/services/modal-control.service';
import { UiBlockService } from 'src/app/services/ui-block.service';
import { finalize } from 'rxjs';
import { PointsService } from 'src/app/services/points.service';

export interface UserProfileData {
  userName: string;
  email: string;
  userState: string;
  organizationType: string;
  organizationName: string;
  demeterLicenseAgreement: boolean;
  licenseEndDate: string;
  userApprovalRequestStr?: string;
}

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['../../app.component.scss', 'user-profile.component.scss'],
  standalone: false
})
export class UserProfileComponent implements OnInit {
  modalTitle = 'User Profile';
  userProfile: UserProfileData | null = null;
  loading = false;

  constructor(
    public bsModalRef: BsModalRef,
    private http: HttpClient,
    private endpointService: EndpointsService,
    private modalControlService: ModalControlService,
    private uiBlockService: UiBlockService,
    private pointsService: PointsService
  ) { }

  ngOnInit(): void {
    this.loadUserProfile();
  }

  loadUserProfile(): void {
    this.loading = true;
    this.uiBlockService.startBlock('Loading user profile...');

    this.http.get<UserProfileData>(
      this.endpointService.getUserProfile,
      this.endpointService.httpOptions
    ).pipe(
      finalize(() => {
        this.loading = false;
        this.uiBlockService.stopBlock();
      })
    ).subscribe({
      next: (data: UserProfileData) => {
        // Extract displayName from userApprovalRequestStr if present
        if (data.userApprovalRequestStr) {
          try {
            const info = JSON.parse(data.userApprovalRequestStr);
            if (info.displayName) {
              data.userName = info.displayName;
            } else if (info.firstName && info.lastName) {
              data.userName = info.firstName + ' ' + info.lastName;
            }
          } catch {}
        }
        this.userProfile = data;
      },
      error: (e) => {
        console.error('Error fetching user profile.', e);
        this.modalControlService.showMesssageModal(
          this.modalTitle,
          'There was an error fetching your profile information.'
        );
      }
    });
  }

  getLicenseAgreementText(): string {
    return this.userProfile?.demeterLicenseAgreement ? 'Accepted' : 'Not Accepted';
  }

  formatDate(dateString: string | null | undefined): string {
    if (!dateString) {
      return 'N/A';
    }
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    } catch {
      return dateString;
    }
  }
}
